import React from 'react';
import { Button, Tag } from 'antd';
import { SendOutlined } from '@ant-design/icons';

const STATUS_COLORS = {
  PENDING: 'default',
  SENT: 'success',
  FAILED: 'error',
};

const BROADCAST_STATUS_COLORS = {
  DRAFT: 'default',
  SCHEDULED: 'processing',
  PARTIALLY_SENT: 'warning',
  COMPLETED: 'success',
  CANCELLED: 'error',
};

export function getTargetGroupColumns({ onSendOne, sendingGroupUuid }) {
  return [
    {
      title: 'Group',
      dataIndex: 'group_name',
      key: 'group_name',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={STATUS_COLORS[status] || 'default'}>{status}</Tag>
      ),
    },
    {
      title: 'Error',
      dataIndex: 'error_message',
      key: 'error_message',
      render: (value) => value || '—',
    },
    {
      title: '',
      key: 'actions',
      width: 120,
      render: (_, row) => (
        <Button
          type="primary"
          size="small"
          icon={<SendOutlined />}
          disabled={row.status === 'SENT' || sendingGroupUuid === row.uuid}
          loading={sendingGroupUuid === row.uuid}
          onClick={() => onSendOne(row.uuid)}
        >
          Send
        </Button>
      ),
    },
  ];
}

export function getHistoryColumns() {
  return [
    {
      title: 'Created',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value) => (value ? new Date(value).toLocaleString() : '—'),
    },
    {
      title: 'Caption',
      dataIndex: 'caption',
      key: 'caption',
      ellipsis: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={BROADCAST_STATUS_COLORS[status] || 'default'}>{status}</Tag>
      ),
    },
    {
      title: 'Cron sent',
      dataIndex: 'cron_sent_at',
      key: 'cron_sent_at',
      render: (value) => (value ? new Date(value).toLocaleString() : '—'),
    },
    {
      title: 'Sent / Failed / Total',
      key: 'send_summary',
      render: (_, row) => {
        const s = row.send_summary || {};
        return `${s.sent ?? 0} / ${s.failed ?? 0} / ${s.total ?? 0}`;
      },
    },
  ];
}

export const CAPTION_MAX_LENGTH = 1024;

export default {
  getTargetGroupColumns,
  getHistoryColumns,
  CAPTION_MAX_LENGTH,
};
